import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Auth} from '../../providers/auth';
import 'rxjs/add/operator/debounceTime';
import {Subject} from 'rxjs/Subject';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-recovery-pass',
  templateUrl: './recovery-pass.component.html',
  styleUrls: ['./recovery-pass.component.css']
})
export class RecoveryPassComponent implements OnInit {

  userId: string;
  token: string;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private spinner: NgxSpinnerService,
              private auth: Auth,
              private fb: FormBuilder) {
  }

  private _success = new Subject<string>();
  successMessage: string;
  alertType = 'danger';
  pending = false;

  form: FormGroup;

  changePass() {
    if (this.pending) return;
    if (this.form.invalid) {
      return;
    }
    const newPass = this.form.get('newPass').value;
    const confirmPass = this.form.get('confirmPass').value;
    if (newPass !== confirmPass) {
      this.alertType = 'danger';
      this._success.next('Las contraseñas no coinciden');
      return;
    }
    const body = {
      username: this.form.get('username').value,
      newPass: newPass,
      token: this.token
    };
    this.pending = true;
    this.spinner.show();
    this.auth.changePassRecovery(body).subscribe((res: any) => {
      this.spinner.hide();
      this.pending = false;
      this.alertType = 'success';
      this._success.next(res && res.message
        ? res.message
        : 'Cambio de Contraseña Exitoso');
      this.form.reset();
    }, err => {
      console.error('ERROR', err);
      this.spinner.hide();
      this.pending = false;
      this.alertType = 'danger';
      this._success.next(err.error && err.error.message
        ? err.error.message
        : 'Error al cambiar la contraseña. Intente nuevamente.');
    });
  }

  irALogin() {
    this.router.navigate(['login']);
  }

  onKeydown(event) {
    if (event.key === 'Enter') {
      this.changePass();
    }
  }

  ngOnInit(): void {
    this.userId = this.route.snapshot.params['userId'];
    this.token = this.route.snapshot.params['token'];

    this.form = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      newPass: ['', [Validators.required, Validators.minLength(6)]],
      confirmPass: ['', [Validators.required]]
    });

    this._success.subscribe((message) => this.successMessage = message);
    this._success.debounceTime(10000).subscribe(() => this.successMessage = null);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/recovery-pass/recovery-pass.component.ts